<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1sgYSX/Images/cover.jpg?1684306038511" alt="This image is the cover for the book Barns of Maine: Our History, Our Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Barns of Maine: Our History, Our Stories
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Although humble in their function, these carefully crafted barns have shaped the landscape of Maine for centuries.</b></p><br/><p>Built long before the days of plastic and plywood, the barns have survived for generations, each with a story to tell. In Bridgton, one barn offered comfort to a 16 year-old boy when his father was injured; another New Gloucester barn was so important to one family that its likeness was engraved on their headstones. Some owners said they would rather see their homes burn than their barns, and others have dedicated their lives and countless funds to restoring and preserving these buildings. From modest English to grand Victorian, Don Perkins examines the structures, origins, and evolution of Maine's barns, demonstrating the vital and precious role they play in people's lives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Perkins
      </h2>
      
      <p class="authorDescription body article">Don Perkins is a former carpenter who found a second career in freelance writing. He now lives on Sebago Lake and writes on everything from classic cars to ice harvesting to barns. He writes a column for the Portland Press Herald, and gives presentations and leads barn tours for historical societies.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?32730e3e